module.exports = __webpack_public_path__ + "static/media/batteries-email-header.9b4bfda5.png";